import { Typography } from "antd";
import { Link } from "react-router-dom";
import { useTranslation } from "../../i18n";
import ArchiveMarkdown from "./ArchiveMarkdown";

const { Title, Paragraph } = Typography;

function ExpiredPanel({ archiveMarkdown = "" }) {
    const { t } = useTranslation();
    const normalizedArchiveMarkdown =
        typeof archiveMarkdown === "string" ? archiveMarkdown.trim() : "";

    return (
        <div className="delivery-card delivery-status">
            <Title level={3}>{t("delivery.expired.title")}</Title>
            <Paragraph className="delivery-status__text">
                {t("delivery.expired.body")}
            </Paragraph>
            {normalizedArchiveMarkdown && (
                <div className="delivery-status__text">
                    <div>{t("delivery.expired.archiveBody")}</div>
                    <ArchiveMarkdown value={normalizedArchiveMarkdown} />
                </div>
            )}
            <Paragraph className="delivery-status__contact">
                <a href="mailto:contact@heicreative.co.uk">contact@heicreative.co.uk</a>
            </Paragraph>
            <Paragraph>
                <Link to="/">{t("common.backHome")}</Link>
            </Paragraph>
        </div>
    );
}

export default ExpiredPanel;
